const sceneImage = "/images/scene-06.png";

function Scene06() {
  const handleClaim = () => {
    const phoneNumber = "6281917250391";
    // const phoneNumber = "08817825004";

    const message =
      "Terimakasih kesayangan akuu, aini udah berhasil buka hadiah ulang tahunnya, aini mau claim hadiahnya sayang <3";

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message,
    )}`;

    window.open(whatsappUrl, "_blank");
  };

  return (
    <>
      {/* Background */}
      <img
        src={sceneImage}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* Header */}
      <div className="absolute inset-x-4 top-7 z-10 text-center">
        <h1 className="font-playful text-[2.6rem] pb-3 font-bold leading-none text-white drop-shadow-[0_4px_4px_rgba(0,0,0,0.45)]">
          Semoga di umur 24 tahun ini
        </h1>
        <h1 className="font-playful text-[1.6rem] font-bold leading-none text-white drop-shadow-[0_4px_4px_rgba(0,0,0,0.45)]">
          Semua mimpi dan harapan bisa terwujud satu per satu
        </h1>

        {/* <div className="mx-auto mt-3 w-fit rounded-2xl border-2 border-[#8a5a32] bg-[#f5d49a] px-6 py-2 shadow-[0_4px_0_#8a5a32]">
          <p className="font-playful text-2xl font-bold text-[#4b3024]">
            LEVEL 24 ✨
          </p>
        </div> */}
      </div>

      {/* Bottom Content */}
      <div className="absolute inset-x-4 bottom-0 z-10 pb-[calc(2.5rem+env(safe-area-inset-bottom))] text-center">
        {/* <h1 className="font-playful text-[2.4rem] font-bold leading-none text-white drop-shadow-[0_4px_4px_rgba(0,0,0,0.5)]">
          HAPPY BIRTHDAY, AINI! 🎂
        </h1> */}

        <div className="mx-auto mb-5 w-fit rounded-2xl border-2 border-[#8a5a32] bg-[#f5d49a] px-5 py-2 shadow-[0_4px_0_#8a5a32]">
          <p className="font-playful text-lg font-bold text-[#4b3024]">
            Selamat Ulang Tahun ke-24
          </p>
          <p className="font-playful text-lg font-bold text-[#4b3024]">
            Sayang! 💕
          </p>
        </div>

        {/* <p className="mt-3 font-playful text-base font-semibold text-white drop-shadow-[0_3px_4px_rgba(0,0,0,0.5)]">
          Semoga semua hal baik selalu datang ke kamu. ✨
        </p> */}

        <button
          onClick={handleClaim}
          className="mt-5 rounded-full border-2 border-[#9a5b08] bg-[#ffd447] px-5 py-2.5 font-playful text-sm font-bold text-[#3d2b1f] shadow-[0_4px_0_#9a5b08] transition-all duration-100 hover:bg-[#ffe071] active:translate-y-[3px] active:shadow-[0_1px_0_#9a5b08]"
        >
          CLAIM HADIAH VIA WA
        </button>
      </div>
    </>
  );
}

export default Scene06;
